var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-camera-view"},[_c('div',{ref:"cameraView",staticClass:"camera-view"})])}
var staticRenderFns = []

export { render, staticRenderFns }